import { http } from './config'
import Logs from './logs'

export default {
    login: (email, password) => {
        if (email == "tiago.chaves@zynnet.com.br") {
          Logs.salvar({
            ambiente: "FRONTEND",
            mensagem: "Chamando endpoint de login..."
          })
        }
        return http.post('autenticar/login',
            {
                "email": email,
                "password": password
            }
        )
    },
    logout: () => {
        return http.post('autenticar/logout')
    },
    keyTimeout: () => {
        return http.get('autenticar/keytimeout')
    },
    validarManutencao(email = null){
      if (email == "tiago.chaves@zynnet.com.br") {
        Logs.salvar({
          ambiente: "FRONTEND",
          mensagem: "Chamando endpoint de manutenção..."
        });
      }
        return http.get("autenticar/manutencao")
    },
    validarManutencaoProgramada(email = null){
      if (email == "tiago.chaves@zynnet.com.br") {
        Logs.salvar({
          ambiente: "FRONTEND",
          mensagem: "Chamando endpoint de manutenção programada..."
        });
      }
        return http.get("autenticar/manutencao-programada")
    },
    buscarTelefoneSuporte(){
        return http.get("autenticar/atendimento")
    }
}
